module.exports = __webpack_public_path__ + "static/carou2-343a512c06238046142ab75f281d31dc.jpg";